import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ComingSoon from "@/pages/ComingSoon";
import AdminJournal from "@/pages/AdminJournal";
import JournalArchive from "@/pages/JournalArchive";
import JournalEntry from "@/pages/JournalEntry";
import Press from "@/pages/Press";
import Feedback from "@/pages/Feedback";
import AdminFeedback from "@/pages/AdminFeedback";
import { DevStatusBanner } from "@/components/DevStatusBanner";
import { SurgeryNotice } from "@/components/SurgeryNotice";
import { captureIncomingReferral } from "@/lib/referral";
import { AnalyticsTracker } from "@/lib/analytics";

function App() {
  useEffect(() => {
    captureIncomingReferral();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <SurgeryNotice />
        <DevStatusBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/journal" element={<JournalArchive />} />
          <Route path="/journal/:slug" element={<JournalEntry />} />
          <Route path="/press" element={<Press />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/admin/journal" element={<AdminJournal />} />
          <Route path="/admin/feedback" element={<AdminFeedback />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
